module.exports = __webpack_public_path__ + "img/keyreply-bot-customer-service-dead.1d9c6390.png";